import logo from '@/assets/hiredcoach-logo.svg';
import React from 'react';

interface InterviewPreparingWaitProps {
  status: string;
}

const getStatusMessage = (status: string): string => {
  switch (status.toUpperCase()) {
    case 'CREATING':
      return 'Signaling the Coach...';
    case 'RESEARCHING':
      return 'Researching your industry and experience. This can take a few minutes.';
    case 'GENERATING':
      return 'Generating personalized questions. This should only take a minute or two more.';
    default:
      return 'Preparing your interview...';
  }
};

const InterviewPreparingWait: React.FC<InterviewPreparingWaitProps> = ({ status }) => (
  <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 animate-fade-in">
    <div className="bg-white dark:bg-card rounded-2xl shadow-xl p-12 max-w-2xl w-full flex flex-col items-center">
      <h1 className="flex items-center gap-2 text-xl text-primary font-semibold mb-2">We&apos;re preparing your interview</h1>
      <img src={logo} alt="HiredCoach Logo" className="w-28 mb-4" />
      <div className="flex items-center gap-2 text-xl text-primary font-semibold mb-2">
        This might take a minute...
      </div>
      <div className="flex flex-col items-center">
        <svg className="animate-spin w-12 h-12 text-primary mb-2" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />
        </svg>
        <span className="text-sm text-muted-foreground">{getStatusMessage(status)}</span>
      </div>
    </div>
  </div>
);

export default InterviewPreparingWait;
